import { ITrackParameter } from "@/types/map";
import { loadModules } from "esri-loader";

export default class TrackPlay {
  private view!: __esri.MapView;
  private static intances: Map<string, TrackPlay>;
  private trackLayer!: __esri.GraphicsLayer;
  private trackLabelLayer!: __esri.GraphicsLayer;
  private MoveStart: boolean = true;
  private movePointSymbol: any = {
    type: "picture-marker",
    url: "assets/mapIcons/icon_ship_green02.png",
    width: 13,
    height: 29,
    angle: 0,
  };

  private constructor(view: __esri.MapView) {
    this.view = view;
  }
  public static getInstance(view: __esri.MapView) {
    const id = view.container.id;
    if (!TrackPlay.intances) {
      TrackPlay.intances = new Map();
    }
    let instance = TrackPlay.intances.get(id);
    if (!instance) {
      instance = new TrackPlay(view);
      TrackPlay.intances.set(id, instance);
    }
    return instance;
  }
  public stopTrackPlay() {
    this.MoveStart = false;
    if (this.trackLayer) {
      this.trackLayer.removeAll();
    }
    if (this.trackLabelLayer) {
      this.trackLabelLayer.removeAll();
    }
  }
  public async startTrackPlay(params: ITrackParameter) {
    this.stopTrackPlay();
    let id = params.id || (Math.random() * 10000).toFixed(0);
    let points = params.overlays; //[{geometry:{x:121.31,y:31.21},fields:{"time":"2021"}}]
    let showTrackPoint = params.showPoint === true;
    let repeat = params.repeat === undefined ? -1 : params.repeat;
    let callback = params.callback;
    let startMove = params.move === true;
    this.MoveStart = startMove;
    type MapModules = [
      typeof import("esri/layers/GraphicsLayer"),
      typeof import("esri/Graphic"),
      typeof import("esri/geometry/Point"),
      typeof import("esri/geometry/Polyline"),
      typeof import("esri/geometry/support/jsonUtils"),
      typeof import("esri/geometry/support/webMercatorUtils")
    ];
    const [
      GraphicsLayer,
      Graphic,
      Point,
      Polyline,
      geometryJsonUtils,
      webMercatorUtils,
    ] = await (loadModules([
      "esri/layers/GraphicsLayer",
      "esri/Graphic",
      "esri/geometry/Point",
      "esri/geometry/Polyline",
      "esri/geometry/support/jsonUtils",
      "esri/geometry/support/webMercatorUtils",
    ]) as Promise<MapModules>);

    if (!this.trackLayer) {
      this.trackLayer = new GraphicsLayer();
      this.trackLabelLayer = new GraphicsLayer();
      this.trackLabelLayer.minScale = 40000;
      this.view.map.add(this.trackLayer);
      this.view.map.add(this.trackLabelLayer);
    } else {
      this.trackLayer.removeAll();
      this.trackLabelLayer.removeAll();
    }

    let paths: Array<Array<number>> = [];
    let trackPointGra: Array<__esri.Graphic> = [];

    let trackPointSymbol: any = {
      type: "simple-marker",
      style: "circle",
      size: 10,
      outline: {
        type: "simple-line",
        color: "white",
        width: 1,
      },
      color: "#ff0000",
    };
    let startPointSymbol = {
      type: "picture-marker",
      url: "assets/mapIcons/icon_start.png",
      width: 20,
      height: 32,
      yoffset: 16,
    };
    let endPointSymbol = {
      type: "picture-marker",
      url: "assets/mapIcons/icon_end.png",
      width: 20,
      height: 32,
      yoffset: 16,
    };
    let textbgSymbol = {
      type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
      style: "path",
      color: [2, 36, 63, 0.5], //"#02243f",
      size: 120, // pixels
      path: "M0 0 H 220 V 30 H 0 Z",
      yoffset: -16,
      outline: {
        // autocasts as new SimpleLineSymbol()
        color: "#2098a5",
        width: 1, // points
      },
    };

    let startGra: any, endGra: any;
    let texts: __esri.Graphic[] = [];
    for (let i = 0; i < params.overlays.length; i++) {
      let overlay = params.overlays[i];
      //轨迹线
      paths.push([overlay.geometry.x, overlay.geometry.y]);
      //轨迹点
      let pointGeometry = geometryJsonUtils.fromJSON(overlay.geometry);
      let fields = overlay.fields || {};
      let gra = new Graphic({
        geometry: pointGeometry,
        symbol: trackPointSymbol,
        attributes: fields,
      });

      let textSymbol = {
        text: fields.time,
        type: "text", // autocasts as new TextSymbol()
        color: "white",
        font: {
          // autocast as new Font()
          family: "Just Another Hand",
          size: 12,
        },
        yoffset: -21,
        horizontalAlignment: "justify",
        verticalAlignment: "bottom",
      };
      texts.push(
        new Graphic({
          geometry: pointGeometry,
          symbol: textbgSymbol,
          attributes: fields,
        }),
        new Graphic({
          geometry: pointGeometry,
          symbol: textSymbol,
          attributes: fields,
        })
      );
      if (i == 0) {
        startGra = new Graphic({
          geometry: pointGeometry,
          symbol: startPointSymbol as any,
          attributes: fields,
        });
      }
      if (i == params.overlays.length - 1) {
        endGra = new Graphic({
          geometry: pointGeometry,
          symbol: endPointSymbol as any,
          attributes: fields,
        });
      }
      trackPointGra.push(gra);
    }

    //添加轨迹线
    let lineGra;
    let arrowGras: __esri.Graphic[] = [];
    if (paths.length > 1) {
      lineGra = new Graphic({
        geometry: {
          type: "polyline",
          paths: [paths],
        } as __esri.Polyline,
        symbol: { type: "simple-line", color: "blue", width: 2 } as any,
      });
      //在轨迹线终点添加箭头
      for (let i = 0; i < paths.length - 1; i++) {
        let start = paths[i];
        let end = paths[i + 1];
        if (
          Math.abs(start[0] - end[0]) > 0.00012 ||
          Math.abs(start[0] - end[0]) > 0.00012
        ) {
          let angle = this.computeAngle(end, start);
          let arrow = new Graphic({
            geometry: {
              type: "point",
              latitude: (start[1] + end[1]) / 2,
              longitude: (start[0] + end[0]) / 2,
            } as __esri.Point,
            symbol: {
              type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
              style: "path",
              angle: angle,
              color: "#7FFFAA", //"#02243f",
              size: 15, // pixels
              path: "M14.5,29 23.5,0 14.5,9 5.5,0z",
              outline: {
                // autocasts as new SimpleLineSymbol()
                color: "#7FFFAA",
                width: 1, // points
              },
            } as any,
          });
          arrowGras.push(arrow);
        }
      }
      this.trackLayer.add(lineGra);
      this.trackLayer.addMany(arrowGras);
    }
    if (showTrackPoint) {
      //添加轨迹点
      this.trackLabelLayer.addMany(trackPointGra);
    }
    //添加时间
    this.trackLabelLayer.addMany(texts);
    //添加起点终点
    this.trackLayer.add(startGra);
    this.trackLayer.add(endGra);
    //this.view.goTo({target: endGra ? endGra : startGra, scale: 20000});
    if (lineGra) {
      this.goToView(lineGra);
    } else {
      this.goToView(startGra);
    }

    if (startMove) {
      this.startMove(paths, id, repeat, (id: string, count: number) => {
        //轨迹播放完成回调
        //console.log(id, count);
        if (repeat > 0 && count + 1 == repeat) {
          if (callback) {
            callback();
          }
        }
      });
    }
  }
  private goToView(graphic: any) {
    if (graphic.geometry.type == "polyline") {
      let ext = graphic.geometry.extent;
      if (ext.xmax - ext.xmin > 0.03 || ext.ymax - ext.ymin > 0.015) {
        this.view.goTo({ target: graphic });
        return;
      }
    }

    this.view.goTo({ target: graphic.clone(), scale: 5000 });
  }
  private async startMove(
    points: Array<Array<number>>,
    moveid: string,
    repeat: number,
    callback: any
  ) {
    let polyline = await this.compactLine(points);
    let compactPaths = polyline.paths[0];
    let path = {
      paths: compactPaths,
      moveid: moveid,
      moveIndex: 0,
      movePaths: [],
      graphic: undefined,
      repeat,
      repeatCount: 0,
      callback,
    };
    this.movePoint(path);
  }
  //致密线
  private async compactLine(points: Array<Array<number>>) {
    const [
      geometryJsonUtils,
      geodesicUtils,
      geometryEngine,
      Graphic,
    ] = await loadModules([
      "esri/geometry/support/jsonUtils",
      "esri/geometry/support/geodesicUtils",
      "esri/geometry/geometryEngine",
      "esri/Graphic",
    ]);
    let geometry = geometryJsonUtils.fromJSON({
      paths: [points],
    });
    let compactPoint = geometryEngine.geodesicDensify(geometry, 50);
    return compactPoint;
  }
  public async movePoint(obj: {
    paths: Array<Array<number>>;
    moveIndex: number;
    moveid: string;
    movePaths: Array<Array<number>>;
    graphic?: __esri.Graphic;
    repeat: number;
    repeatCount: number;
    callback?: any;
  }) {
    const [geometryJsonUtils, geometryEngine, Graphic] = await loadModules([
      "esri/geometry/support/jsonUtils",
      "esri/geometry/geometryEngine",
      "esri/Graphic",
    ]);
    let _this = this;
    let index = obj.moveIndex;
    if (index < obj.paths.length - 1) {
      let currentPoint = obj.paths[index];
      let endPoint = obj.paths[index + 1];
      let geometry = geometryJsonUtils.fromJSON({
        x: currentPoint[0],
        y: currentPoint[1],
      });
      if (obj.moveIndex == 0 && obj.repeatCount == 0) {
        obj.graphic = new Graphic({
          geometry,
          symbol: _this.movePointSymbol,
        });
        this.trackLayer.add(obj.graphic as __esri.Graphic);
      }
      if (obj.graphic) {
        obj.graphic.geometry = geometry;
        (obj.graphic
          .symbol as __esri.PictureMarkerSymbol).angle = _this.computeAngle(
          currentPoint,
          endPoint
        );
      }
      if (_this.MoveStart) {
        obj.moveIndex++;
        setTimeout(() => {
          _this.movePoint(obj);
        }, 10);
      }
    } else {
      if (obj.callback) {
        obj.callback(obj.moveid, obj.repeatCount);
      }
      obj.repeatCount++;
      if (obj.repeat == 0 || (obj.repeat > 0 && obj.repeatCount < obj.repeat)) {
        if (_this.MoveStart) {
          obj.moveIndex = 0;
          setTimeout(() => {
            _this.movePoint(obj);
          }, 10);
        }
      }
    }
  }
  private computeAngle(pos1: Array<number>, pos2: Array<number>): number {
    const x1 = pos1[0];
    const y1 = pos1[1];
    const x2 = pos2[0];
    const y2 = pos2[1];

    if (x1 === x2) {
      return y2 > y1 ? 0 : 180;
    }

    if (y1 === y2) {
      return x2 > x1 ? 90 : 270;
    }

    const angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);
    let px = 1,
      py = 1;
    if (x2 > x1) {
      px = -1;
    }
    if (y2 > y1) {
      py = -1;
    }
    return ((360 - angle + 90) % 360) - px * py * 5;
  }
}
